import { GmrUnavailableStats } from './gmr.models';

//
// Which of the four reasons why a company is unavailable apply to at least one company: a count which is not zero.
// A count which the preset does not deliver is no reason either.
//
export interface UnavailableAlert
{
  inactive: boolean;
  outsideServiceArea: boolean;
  compliance: boolean;
  unknown: boolean;
  any: boolean;
}

function isSet(count: number | null | undefined): boolean
{
  return count !== null && count !== undefined && !Number.isNaN(Number(count)) && Number(count) !== 0;
}

export function getUnavailableAlert(stats: GmrUnavailableStats | null | undefined): UnavailableAlert
{
  const inactive = isSet(stats?.inactive_cnt);
  const outsideServiceArea = isSet(stats?.outside_service_area_cnt);
  const compliance = isSet(stats?.compliance_cnt);
  const unknown = isSet(stats?.unknown_cnt);

  return {
    inactive
  , outsideServiceArea
  , compliance
  , unknown
  , any: inactive || outsideServiceArea || compliance || unknown
  };
}
